export default __webpack_public_path__ + "static/media/Prozess.26d1bfbd.svg";